import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inner-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './inner-loader.component.html',
  styleUrl: './inner-loader.component.scss',
})
export class InnerLoaderComponent {}
